import React, { useEffect, useState } from 'react'
import PnLCard from './PnLCardSM.jsx'
import { WalletOutlined, StarOutlined, RiseOutlined } from '@ant-design/icons';
import { Cookies } from 'react-cookie';
import useWebSocket from 'react-use-websocket';

const PnLCardGridSM = ({ loginId }) => {
    const [liveData, setLiveData] = useState(null);
    const cookies = new Cookies();

    const { sendJsonMessage, lastJsonMessage } = useWebSocket(`${process.env.REACT_APP_SOCKET_URL}/MTFiveAccount/ws?authorization=Bearer ${cookies.get('token')}`,
        { shouldReconnect: () => true, share: true }
    );

    useEffect(() => {
        sendJsonMessage({ action: "subscribe", eventType: "UserLiveDashboard", loginId });
        return () => {
            sendJsonMessage({ action: "unsubscribe", eventType: "UserLiveDashboard", loginId });
        }
    }, [loginId])

    useEffect(() => {
        if (lastJsonMessage?.eventType === "UserLiveDashboard") {
            setLiveData(lastJsonMessage?.data);
        }
    }, [lastJsonMessage])

    const pnlCards = [
        { type: 'Total Equity', amount: liveData?.Equity || 0.00, color: 'bg-blue-500', gradient: 'from-[#FAF5FF] to-[#ffff]', icon: <WalletOutlined size={20} color='#fff' className='text-white' /> },
        { type: 'Total Profit', amount: liveData?.Profit || 0.00, color: 'bg-green-500', gradient: 'from-[#F0FDF4] to-[#ffff]', icon: <RiseOutlined size={20} color='#fff' className='text-white' /> },
        { type: 'Used Margin', amount: liveData?.Margin || 0.00, color: 'bg-teal-500', gradient: 'from-[#FFF7ED] to-[#ffff]', icon: <StarOutlined size={20} color='#fff' className='text-white' /> },
        { type: 'Free Margin', amount: liveData?.MarginFree || 0.00, color: 'bg-red-500', gradient: 'from-[#FFEDED] to-[#ffff]', icon: <StarOutlined size={20} color='#fff' className='text-white' /> }
    ];
    return (
        <div>
            <div className="grid grid-cols-4 gap-3">
                {pnlCards.map((card, index) => (
                    <PnLCard
                        key={card.id || index}
                        type={card.type}
                        amount={card.amount}
                        color={card.color}
                        gradient={card.gradient}
                        icon={card.icon}
                    />
                ))}
            </div>
        </div>
    )
}

export default PnLCardGridSM
